export interface ServerSentEventRecord {
  id?: string;
  event?: string;
  data: string;
}

export async function readServerSentEvents(
  stream: ReadableStream<Uint8Array>,
  onRecord: (record: ServerSentEventRecord) => void,
  onActivity?: () => void,
) {
  const reader = stream.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let id: string | undefined;
  let event: string | undefined;
  let data: string[] = [];

  const dispatch = () => {
    if (data.length === 0) return;
    onRecord({ id, event, data: data.join("\n") });
    event = undefined;
    data = [];
  };

  const consumeLine = (line: string) => {
    if (line === "") {
      dispatch();
      return;
    }
    if (line.startsWith(":")) return;
    const separator = line.indexOf(":");
    const field = separator < 0 ? line : line.slice(0, separator);
    const rawValue = separator < 0 ? "" : line.slice(separator + 1);
    const value = rawValue.startsWith(" ") ? rawValue.slice(1) : rawValue;
    if (field === "id" && !value.includes("\0")) id = value;
    else if (field === "event") event = value;
    else if (field === "data") data.push(value);
  };

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (value && value.byteLength > 0) onActivity?.();
      buffer += decoder.decode(value, { stream: !done });
      const lines = buffer.split(/\r?\n/);
      buffer = lines.pop() ?? "";
      lines.forEach(consumeLine);
      if (done) break;
    }
    if (buffer !== "") consumeLine(buffer);
    dispatch();
  } finally {
    reader.releaseLock();
  }
}
